module.exports = __webpack_public_path__ + "img/far_night_cyl125_axis45.c53cb15c.jpg";